.popupSize {
  padding: 0 10px 7px 10px;
}
